import { usePut } from '../../../sharedModules/hooks/useQuery';

interface UpdatePermanentStatusParams {
  id: number;
  permanentlyDisabled: boolean;
  reason?: string;
}

interface UpdatePermanentStatusResponse {
  id: number;
  collection_enabled: boolean;
  collection_permanently_disabled: boolean;
  collection_permanently_disabled_at: string | null;
  collection_permanently_disabled_reason: string | null;
  collection_permanently_disabled_by: string | null;
}

export function useUpdateCollectionClientPermanentStatus() {
  const mutation = usePut<UpdatePermanentStatusResponse>();

  const updatePermanentStatus = ({ id, permanentlyDisabled, reason }: UpdatePermanentStatusParams) =>
    mutation.mutateAsync({
      url: `/collections/clients/${id}/permanent_status`,
      data: { client: { permanently_disabled: permanentlyDisabled, reason } },
    });

  return {
    updatePermanentStatus,
    isLoading: mutation.isPending,
    isError: mutation.isError,
  };
}
